module.exports = __webpack_public_path__ + "assets/img/Coolabah-Turf-Article.db835caf.jpg";